import type { ContainerSizeInput } from '@chukua/common';
import { Alert, Button, Drawer, Form, Input } from 'antd';
import { useEffect } from 'react';
import type { CatalogueDrawerProps } from '../../../components/CataloguePanel';
import type { ContainerSize } from '../../../reference-data.api';

export function ContainerSizeFormDrawer({ open, editing, error, submitting, onSubmit, onClose }: CatalogueDrawerProps<ContainerSize, ContainerSizeInput>) {
  const [form] = Form.useForm<ContainerSizeInput>();

  useEffect(() => {
    if (open) form.setFieldsValue(editing ?? { code: '', name: '' });
  }, [open, editing, form]);

  async function submit(values: ContainerSizeInput) {
    if (await onSubmit(values)) onClose();
  }

  return (
    <Drawer open={open} onClose={onClose} title={editing ? 'Edit container size' : 'New container size'} placement="right" size={420} destroyOnClose>
      {error && <Alert className="mb-5" type="error" title={error} showIcon />}
      <Form<ContainerSizeInput> form={form} layout="vertical" requiredMark={false} onFinish={submit} disabled={submitting}>
        <Form.Item name="code" label="Code" rules={[{ required: true, message: 'Enter a code' }]}>
          <Input className="font-mono" autoFocus />
        </Form.Item>
        <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Enter a name' }]}>
          <Input />
        </Form.Item>
        <Form.Item className="mb-0 pt-2">
          <Button type="primary" htmlType="submit" loading={submitting}>
            {editing ? 'Save' : 'Create container size'}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
